import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'kt-inventory-dialog',
  templateUrl: './inventory-dialog.component.html',
  styleUrls: ['./inventory-dialog.component.scss']
})
export class InventoryDialogComponent implements OnInit {

	data = {
		low_lvl: 0,
		empty_lvl: 0,
		rem_lvl: 0,
		par: 0
	};

	constructor(public dialogRef: MatDialogRef<InventoryDialogComponent>, @Inject(MAT_DIALOG_DATA) public rxData: any) {}

	ngOnInit() {
		this.data.par = this.rxData.canSize;
		this.data.rem_lvl = parseFloat(((this.rxData.remSize/this.rxData.canSize)*100).toFixed(0));
		this.data.empty_lvl = parseFloat(((this.rxData.emptyLevel/this.rxData.canSize)*100).toFixed(0));
		this.data.low_lvl = parseFloat(((this.rxData.lowLevel/this.rxData.canSize)*100).toFixed(0));
	}

}
